import { Avatar, Box, Card, Chip, FormControl, Grid, Link, List, ListItem, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import statusIcon from "../../../assets/svg/Check icon.svg"
import {  Bar, BarChart, CartesianGrid, Cell, Line, LineChart, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ArrowForward, ArrowUpward, CloseOutlined, } from '@mui/icons-material';
import agentimg from "../../../assets/svg/Ellipse 12.svg"

import { IoTrophyOutline } from 'react-icons/io5';
const OverviewLoyalty = () => {
        const stats = [
            { title: "Total Members", value: 256, subtitle: "18% vs last 30 days" },
            { title: "Active Members", value: 148, subtitle: "8% vs last 30 days" },
            { title: "New Members", value: 28, subtitle: "14% vs last 30 days" },
            { title: "Tier Upgrade Rate", value: 34, subtitle: "In progress" },
            { title: "Points Issued", value: 18, subtitle: "In review" },
            { title: "Points Redeemed", value: 6, subtitle: "9% vs last 30 days" },
            { title: "Points Liability", value: 46, subtitle: "-5% vs last 30 days" },
            { title: "Loyalty ROI", value: 12, subtitle: "9% vs last 30 days" },
            { title: "Redemption Rate", value: 12, subtitle: "9% vs last 30 days" },
            { title: "Repeat Purchase Rate", value: 12, subtitle: "9% vs last 30 days" },
            { title: "Expired Points", value: 12, subtitle: "9% vs last 30 days" },
            { title: "Avg. Points per Member", value: 12, subtitle: "9% vs last 30 days" },
        ];
        const data = [
        { date: "Apr 28", issued: 90000, redeemed: 70000, expired: 42000 },
        { date: "May 01", issued: 120000, redeemed: 80000, expired: 35000 },
        { date: "May 05", issued: 102000, redeemed: 82000, expired: 38000 },
        { date: "May 08", issued: 128000, redeemed: 76000, expired: 32000 },
        { date: "May 12", issued: 190000, redeemed: 113000, expired: 62000 },
        { date: "May 15", issued: 178000, redeemed: 98000, expired: 55000 },
        { date: "May 19", issued: 176000, redeemed: 130000, expired: 90000 },
        { date: "May 23", issued: 215000, redeemed: 125000, expired: 85000 },
        { date: "May 27", issued: 228000, redeemed: 128000, expired: 88000 },
        { date: "May 31", issued: 240000, redeemed: 148000, expired: 102000 },
    ];
    
    const visibleTicks = ["Apr 28", "May 05", "May 12", "May 19", "May 31"];
    
    
    
    const HollowDot = ({ cx, cy, stroke }) => (
        <circle cx={cx} cy={cy} r={5} fill="#fff" stroke={stroke} strokeWidth={2} />
    );
    
    const CustomLegend = () => {
        const items = [
            { name: "Issued", color: "#7E1BAD" },
            { name: "Redeemed", color: "#000000" },
            { name: "Expired", color: "#A80101" },
        ];
    
        return (
            <Box sx={{ display: "flex", gap: 3, mb: 2, pl: 1 }}>
                {items.map((item) => (
                    <Box key={item.name} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                        <Box
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                bgcolor: item.color,
                            }}
                        />
                        <Typography sx={{ fontSize: 13 }}>{item.name}</Typography>
                    </Box>
                ))}
            </Box>
        );
    };
    
    const barData = [
        { date: "May 01", value: 180000 },
        { date: "May 02", value: 260000 },
        { date: "May 03", value: 550000 },
        { date: "May 04", value: 410000 },
        { date: "May 05", value: 330000 },
        { date: "May 06", value: 250000 },
        { date: "May 07", value: 190000 },
        { date: "May 08", value: 440000 },
        { date: "May 09", value: 560000 },
        { date: "May 10", value: 850000 },
        { date: "May 11", value: 330000 },
        { date: "May 12", value: 260000 },
        { date: "May 13", value: 420000 },
        { date: "May 14", value: 260000 },
        { date: "May 15", value: 260000 },
        { date: "May 16", value: 820000 },
        { date: "May 17", value: 580000 },
        { date: "May 18", value: 330000 },
        { date: "May 19", value: 260000 },
        { date: "May 20", value: 190000 },
        { date: "May 21", value: 260000 },
        { date: "May 22", value: 550000 },
        { date: "May 23", value: 410000 },
        { date: "May 24", value: 900000 },
        { date: "May 25", value: 270000 },
        { date: "May 26", value: 190000 },
        { date: "May 27", value: 720000 },
        { date: "May 28", value: 550000 },
        { date: "May 29", value: 410000 },
        { date: "May 30", value: 330000 },
        { date: "May 31", value: 260000 },
    ];
    
    const visibleBarTicks = ["May 01", "May 06", "May 11", "May 16", "May 21", "May 26", "May 31"]
    
    
     const donutTier = [
            { name: "Platinum", value:5250, color: "#7E1BAD" },
            { name: "Gold", value:10450 , color: "#FEB91E" },
            { name: "Silver", value: 18200, color: "#3E9FF6" },
            { name: "Bronze", value:14620 , color: "#FC6C4F" },
        ];
    
        const total = donutTier.reduce((sum, item) => sum + item.value, 0);
     const expiredPointsDonut = [
            { name: "0 - 30 days", value:155000, color: "#3FBEAC"},
            { name: "31 - 90 days", value:303000, color: "#3E9FF6"},
            { name: "91 - 180 days", value:357000, color: "#FEB91E"},
            { name: "181 - 365 days", value:305000, color: "#7E1BAD"},
            { name: "> 365 days", value:125000, color: "#FC6C4F"},
           
        ];
    
        const totalExpiredPointsDonut = expiredPointsDonut.reduce((sum, item) => sum + item.value, 0);
    
    
        const rows = [
            {
                id: "1", name: "Ahmed Mohamed", lifetime_spend: "25,640", points_balance: "12,850",
                total_orders: "48",
                tier: { name: "Platinum", bgColor: "#F6E9FC",},
            },
            {
                id: "2", name: "Sarah Ahmed", lifetime_spend: "18,320", points_balance: "8,760",
                total_orders: "32",
                tier: { name: "Gold", bgColor: "#FFFAEA",},
            },
            {
                id: "3", name: "Mona Salah", lifetime_spend: "11,280", points_balance: "4,980",
                total_orders: "21",
                tier: { name: "Silver", bgColor: "#F0F8FF",},
            },
          
        ];
    
    
    const popularRewards = [
        {
         rewardName:"50 EGP Discount", pointsRequired:"500 pts", redeemed:"4,256"
        },
        {
         rewardName:"Free Car Wash", pointsRequired:"1,000 pts", redeemed:"3,215"
        },
        {
         rewardName:"100 EGP Discount", pointsRequired:"1000 pts", redeemed:"2,854"
        },
        {
         rewardName:"Free Inspection", pointsRequired:"1500 pts", redeemed:"1,985"
        },
        {
         rewardName:"100 EGP Discount", pointsRequired:"2000 pts", redeemed:"1,256"
        },
    
    
    ]
    
    const recentActivity = [
            { user: "Ahmed Ali ", action: "earned ", loyalty: "120 Points", time: "20m ago" },
            { user: "Sara Ahmed ", action: "redeemed ", loyalty: "500 Points", time: "1h ago" },
            { user: "Mona Salah ", action: "reached ", loyalty: "Gold Tier", time: "1h ago" },
            { user: "Omar Ali ", action: "earned ", loyalty: "150 Points", time: "2d ago" },
        
        ];
    
        const loyaltyStats = [
        { label: "Repeat Purchase Rate", value: "72.6%", change: "1.8%" },
        { label: "Avg. Orders per Member", value: "6.4", change: "9.3%" },
        { label: "Avg. Spend per Member", value: "3,850 EGP", change: "8.7%" },
        { label: "Program ROI", value: "4.2x", change: "15.2%" },
    ];
    
  return (
    <>
      <Box>
                           <Grid container spacing={2} sx={{ py: 3 }} alignItems="stretch">
                {stats.map((item) => (
                    <Grid item xs={12} sm={6} md={3} key={item.title} sx={{ display: "flex" }}>
                        <Card
                            elevation={0}
                            sx={{
                                border: "1px solid #ECECEC",
                                boxShadow: "0px 1px 4px rgba(0,0,0,0.04)",
                                borderRadius: 3,
                                px: 2.5,
                                py: 2,
                                width: "100%",
                            }}
                        >
                            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                <Box component="img" src={statusIcon} alt="status" sx={{ width: 24, height: 24 }} />
                                <Typography fontWeight={600} fontSize={14}>{item.title}</Typography>
                            </Box>
                            <Typography fontWeight={700} fontSize={22} sx={{ mt: 1 }}>{item.value}</Typography>
                            <Typography color="text.secondary" fontSize={12}>{item.subtitle}</Typography>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Grid container spacing={2} sx={{ py: 3 }} >
                <Grid item xs={12} md={8}>
                                        <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
           height: { xs: "auto", md: 420 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Points Trend</Typography>
                 <Box sx={{ display: "flex", justifyContent: "flex-end"}}>
                    <Box sx={{display:"flex", alignItems:"center", gap:2}}>
                                <FormControl size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", fontSize: 13 } }}>
                                <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                    <MenuItem value="all">Last 30 Days</MenuItem>
                                    <MenuItem value="active">Last 20 Days</MenuItem>
                                    <MenuItem value="inactive">Last 10 Days</MenuItem>
                                </Select>
                            </FormControl>
                                <FormControl size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", fontSize: 13 } }}>
                                <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                    <MenuItem value="all">All Tiers</MenuItem>
                                </Select>
                            </FormControl>
                    </Box>
                        </Box>
            
        </Box>
            <Box sx={{ width: "100%" }}>
        <CustomLegend />

        <Box sx={{ width: "100%", height: 300 }}>
            <ResponsiveContainer>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />

                    <XAxis
                        dataKey="date"
                        ticks={visibleTicks}
                        interval={0}
                        axisLine={false}
                        tickLine={false}
                    />

                    <YAxis
                        domain={[0, 250000]}
                        ticks={[0, 50000, 100000, 150000, 200000, 250000]}
                        tickFormatter={(v) => `${v / 1000}K`}
                        axisLine={false}
                        tickLine={false}
                    />

                    <Tooltip />

                    <Line
                        type="monotone"
                        dataKey="issued"
                        stroke="#7E1BAD"
                        strokeWidth={2}
                        dot={<HollowDot />}
                        activeDot={{ r: 6 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="redeemed"
                        stroke="#000000"
                        strokeWidth={2}
                        dot={<HollowDot />}
                        activeDot={{ r: 6 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="expired"
                        stroke="#A80101"
                        strokeWidth={2}
                        dot={<HollowDot />}
                        activeDot={{ r: 6 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </Box>
    </Box>
    </Card>
        <Box my={2}>
  <Card
    elevation={0}
    sx={{
      border: "1px solid #ECECEC",
      borderRadius: 3,
      p: 2,
      height: { xs: "auto", md: 360 },
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #ECECEC",
        pb: 1.5,
        my: 1,
        flexWrap: "wrap",
        gap: 1,
      }}
    >
      <Typography fontWeight={600} fontSize={15}>
        Top Members
      </Typography>

      <Link
        sx={{
          color: "#159D89",
          textDecoration: "none",
          fontSize: 13,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          cursor: "pointer",
        }}
      >
        View all
        <ArrowForward sx={{ fontSize: 14 }} />
      </Link>
    </Box>

    {/* Table */}
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        width: "100%",
        overflowX: {xs:"auto", md:"hidden"},
        my:1,
      }}
    >
      <Table
        sx={{
          minWidth: 700,
           minHeight:"100%",
          "& .MuiTableCell-root": {
            fontSize: 13,
            whiteSpace: "nowrap",
            borderBottom: "1px solid #F0F0F0",
          },

          "& .MuiTableHead-root .MuiTableCell-root": {
            fontSize: 14,
            fontWeight: 600,
            color: "#333",
            backgroundColor: "#FAFAFA",
          },
        }}
      >
        <TableHead>
          <TableRow >
            <TableCell sx={{textAlign:"center", width:50}}>#</TableCell>
            <TableCell sx={{textAlign:"center", width:100}}>Member</TableCell>
            <TableCell sx={{textAlign:"center", width:100}}>Tier</TableCell>
            <TableCell sx={{textAlign:"center", width:90}}>Lifetime Spend</TableCell>
            <TableCell sx={{textAlign:"center", width:90}}> Points Balance</TableCell>
            <TableCell sx={{textAlign:"center", width:90}}>Total Orders</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell sx={{textAlign:"center", width:50}}>
                {row.id}
              </TableCell>

              <TableCell>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent:"start",
                    gap: 1,
                    width:100
                  }}
                >
                  <Avatar
                    src=""
                    sx={{
                      width: 32,
                      height: 32,
                    }}
                  />

                  <Typography fontSize={12}>
                    {row.name}
                  </Typography>
                </Box>
              </TableCell>

              {/* Tier */}
              <TableCell sx={{textAlign:"center", width:100}}>
                <Chip
                  label={row.tier?.name}
                  size="small"
                  sx={{
                    bgcolor: row.tier?.bgColor,
                    fontWeight: 500,
                    px:3,
                    py:1
                  }}
                />
              </TableCell>

              <TableCell sx={{textAlign:"center", width:90}}>
                {row.lifetime_spend}
              </TableCell>

              <TableCell sx={{textAlign:"center", width:90}}>
                {row.points_balance}
              </TableCell>

              <TableCell sx={{textAlign:"center", width:90}}>
                {row.total_orders}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Card>
</Box>
         <Box my={2}>
             <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
           height: { xs: "auto", md: 430 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Points Redemptions Trend</Typography>
                 <Box sx={{ display: "flex", justifyContent: "flex-end"}}>
                                <FormControl size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", fontSize: 13 } }}>
                                <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                    <MenuItem value="all">Last 30 Days</MenuItem>
                                    <MenuItem value="active">Last 20 Days</MenuItem>
                                    <MenuItem value="inactive">Last 10 Days</MenuItem>
                                </Select>
                            </FormControl>
                             
                        </Box>
            
        </Box>

        <Box sx={{ width: "100%", height: "100%", my:1 }}>
            <ResponsiveContainer>
                 <BarChart data={barData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />

                <XAxis
                    dataKey="date"
                    ticks={visibleBarTicks}
                    interval={0}
                    axisLine={false}
                    tickLine={false}
                />

                <YAxis
                    domain={[0, 1000000]}
                    ticks={[0, 200000, 400000, 600000, 800000, 1000000]}
                    tickFormatter={(v) => (v === 1000000 ? "1M" : `${v / 1000}K`)}
                    axisLine={false}
                    tickLine={false}
                />

                <Tooltip />

                <Bar
                    dataKey="value"
                    fill="#3FBEAC"
                    radius={[4, 4, 0, 0]}
                    barSize={16}
                />
            </BarChart>
            </ResponsiveContainer>
        </Box>
    </Card>
            </Box>           
                </Grid>
                <Grid item xs={12} md={4} >
                     <Box>
                                 <Card
            elevation={0}
            sx={{
                border: "1px solid #ECECEC",
                borderRadius: 3,
                p: 2,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                height: { xs: "auto", md: 270 },
                
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ECECEC",
                    pb: 1.5,
                    mb: 1,
                    flexWrap: "wrap",
                    gap: 1,
                }}
            >
                <Typography fontWeight={600} fontSize={15}>Members by Tier</Typography>
            
                
            </Box>
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
              <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 2, flexGrow: 1 }}>
                                        <Box sx={{ width: 180, height: 180, flexShrink: 0 }}>
                                            <ResponsiveContainer>
                                                <PieChart>
                                                    <Pie data={donutTier} dataKey="value" innerRadius={55} outerRadius={78} startAngle={90} endAngle={-270}>
                                                        {donutTier.map((item) => (<Cell key={item.name} fill={item.color} />))}
                                                    </Pie>
                                                    <text x="50%" y="50%" textAnchor="middle" fontSize="28" fontWeight="700">{Number(total).toLocaleString("en-Us")}</text>
                                                    <text x="50%" y="62%" textAnchor="middle" fontSize="13">Total</text>
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </Box>
    
                                        <Box sx={{ flexGrow: 1, minWidth: 140 }}>
                                            {donutTier.map((item) => (
                                                <Box key={item.name} sx={{ display: "flex", alignItems: "center", gap: 1, my: 1 }}>
                                                    <Box sx={{ width: 9, height: 9, borderRadius: "50%", bgcolor: item.color, flexShrink: 0 }} />
                                                    <Typography fontSize={12.5} noWrap>
                                                        {item.value} {item.name} ({((item.value / total) * 100).toFixed(1)}%)
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
            </Box>
        </Card>
    </Box>
  <Box my={2}>
     <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 370 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Popular Rewards</Typography>
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
        </Box>
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
    {/* Header Row */}
    <Grid container sx={{ px: 1, pb: 1 }}>
        <Grid item xs={4}>
            <Typography fontSize={13} color="text.secondary">Reward</Typography>
        </Grid>
        <Grid item xs={4} sx={{ textAlign: "center" }}>
            <Typography fontSize={13} color="text.secondary">Points Required</Typography>
        </Grid>
        <Grid item xs={4} sx={{ textAlign: "right" }}>
            <Typography fontSize={13} color="text.secondary">Redeemed</Typography>
        </Grid>
    </Grid>

    {/* Data Rows */}
    <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        {popularRewards.map((reward, index) => (
            <Grid
                container
                key={index}
                alignItems="center"
                sx={{
                    px: 1,
                    py: 2,
                    borderBottom: index !== popularRewards.length - 1 ? "1px solid #ECECEC" : "none",
                }}
            >
                <Grid item xs={4}>
                    <Typography fontSize={13}>{reward.rewardName}</Typography>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: "center" }}>
                    <Typography fontSize={13}>{reward.pointsRequired}</Typography>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: "right" }}>
                    <Typography fontSize={13}>{reward.redeemed}</Typography>
                </Grid>
            </Grid>
        ))}
    </Box>
</Box>
    </Card>
  </Box>
  <Box my={2}>
                          <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 270 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Recent Activity</Typography>
            
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
            
        </Box>
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
          <List sx={{ py: 0 }}>
                                {recentActivity.map((a, i) => (
                                    <ListItem key={i} sx={{ borderBottom: i < recentActivity.length - 1 ? "1px solid #E8E8E8" : "none", px: 0 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: 1, py: 1 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, minWidth: 0 }}>
                                                <Box sx={{ width: 32, height: 32, borderRadius: "50%", border: "1px solid #E8E8E8", flexShrink: 0, overflow: "hidden" }}>
                                                    <Box component="img" src={agentimg} alt="" sx={{ width: "100%", height: "100%" }} />
                                                </Box>
                                                <Typography fontWeight={600} fontSize={12} sx={{ wordBreak: "break-word" }}>
                                                    {a.user} <Typography component="span" color="text.secondary" fontSize={12}>{a.action}</Typography> {a.loyalty}
                                                </Typography>
                                            </Box>
                                            <Typography fontSize={12} color="text.secondary" sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>{a.time}</Typography>
                                        </Box>
                                    </ListItem>
                                ))}
                            </List>
                            
        </Box>
    </Card>
  </Box>
                   <Box my={2}>
                                 <Card
            elevation={0}
            sx={{
                border: "1px solid #ECECEC",
                borderRadius: 3,
                p: 2,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                height: { xs: "auto", md: 285 },
                
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ECECEC",
                    pb: 1.5,
                    mb: 1,
                    flexWrap: "wrap",
                    gap: 1,
                }}
            >
                <Typography fontWeight={600} fontSize={15}>Points Expiry Overview</Typography>
            
                
            </Box>
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0,}}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexGrow: 1 ,  flexWrap:{ xs:"wrap", md:"nowrap"} }}>
                                        <Box sx={{ width: 160, height: 160, flexShrink: 0 }}>
                                            <ResponsiveContainer>
                                                <PieChart>
                                                    <Pie data={expiredPointsDonut} dataKey="value" innerRadius={55} outerRadius={78} startAngle={90} endAngle={-270}>
                                                        {expiredPointsDonut.map((item) => (<Cell key={item.name} fill={item.color} />))}
                                                    </Pie>
                                                    <text x="50%" y="50%" textAnchor="middle" fontSize="20" fontWeight="700">{Number(totalExpiredPointsDonut).toLocaleString("en-Us")}</text>
                                                    <text x="50%" y="62%" textAnchor="middle" fontSize="13">Total</text>
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </Box>
    
                                        <Box sx={{ flexGrow: 1, }}>
                                            {expiredPointsDonut.map((item) => (
                                                <Box key={item.name} sx={{ display: "flex", alignItems: "center", gap: 1, my: 1 }}>
                                                    <Box sx={{ width: 9, height: 9, borderRadius: "50%", bgcolor: item.color, flexShrink: 0 }} />
                                                    <Typography fontSize={12} noWrap>
                                                    {item.name}
                                                    </Typography>
                                                    <Typography fontSize={12} noWrap>
                                                        {`${item.value / 1000}K`}  ({((item.value / totalExpiredPointsDonut) * 100).toFixed(1)}%)
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
            </Box>
        </Card>
    </Box>
             
                </Grid>
            </Grid>

           <Grid
    container
    sx={{
        p: 2,
        bgcolor: "#ECF9F7",
        borderRadius: 2,
    }}
>
    <Grid
        item
        xs={12}
        md={4}
        sx={{
            pr: 2,
            display: "flex",
            alignItems: "center",
        }}
    >
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                width: "100%",
            }}
        >
            <Box
                sx={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    bgcolor: "#3FBEAC",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                <IoTrophyOutline
                 size={25}
                color='#fff'
                />
            </Box>

            <Box>
                <Typography fontWeight={600} fontSize={12}>
                    Your Loyalty Program Impact
                </Typography>

                <Typography
                    fontSize={12}
                    color="text.secondary"
                    sx={{ mt: 0.3 }}
                >
                    Customers enrolled in the loyalty program place{" "}
                    <Box
                        component="span"
                        fontWeight={700}
                        color="text.primary"
                    >
                        2.3x
                    </Box>{" "}
                    more orders and spend{" "}
                    <Box
                        component="span"
                        fontWeight={700}
                        color="text.primary"
                    >
                        1.8x
                    </Box>{" "}
                    more than non-members
                </Typography>
            </Box>
        </Box>
    </Grid>

    {loyaltyStats.map((stat) => (
        <Grid
            item
            xs={12}
            md={2}
            key={stat.label}
            sx={{
                pl: 2,
                pr: 1,
                borderLeft: {
                    xs: "none",
                    md: "1px solid #DDEDEA",
                },
            }}
        >
            <Typography
                fontSize={12}
                color="text.secondary"
            >
                {stat.label}
            </Typography>

            <Typography
                fontWeight={700}
                fontSize={16}
                sx={{ mt: 0.5 }}
            >
                {stat.value}
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.3,
                    mt: 0.5,
                }}
            >
                <ArrowUpward
                    sx={{
                        fontSize: 12,
                        color: "#3FBEAC",
                    }}
                />

                <Typography
                    fontSize={11}
                    color="#535353"
                >
                    {stat.change} vs last 30 days
                </Typography>
            </Box>
        </Grid>
    ))}
</Grid>
    
           </Box>
    </>
  )
}

export default OverviewLoyalty